// removed by extract-text-webpack-plugin
module.exports = {"Tooltip":"_3uOUIQtPGGOtktnQ5yvRUV","Tooltip__inner":"grR3724CFqZBgvyGNrMkm","Tooltip__mini-profile-angle":"_3JiPSzXgygswpeok8N2JxZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/Tooltip.scss
// module id = 2711
// module chunks = 0